import React from "react";
import { Button, Card, Table } from "react-bootstrap";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IconCopy } from "@tabler/icons-react";
import { detalleSolicitud, retomarSolicitud } from "../actions/solicitudes";
import { updateSaveSolicitud } from "../actions/saveSolicitud";
import { hideAlert, showAlert } from "../actions/alertMessage";
import { getSecurityKey } from "../helpers/SecurityKey";
import { revertDate } from "../helpers/functionGlobal";
import { MensajesAlertas } from "../models/MensajesAlertas";

const CardTabla = ({ items, estatusSelec, listaEstatus }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataUser = useSelector((state) => state.auth);
  const sucursalSelec = useSelector((state) => state.sucursalSelection);
  const securityKey = getSecurityKey();

  const terminarSolicitud = (solicitud) => {
    const { estatus, id, estatusDescripcion } = solicitud;
    if (estatus === null && estatusDescripcion === null) {
      dispatch(retomarSolicitud(solicitud));
      navigate("/solicitud");
    } else {
      //const estatusSelect = listaEstatus.find(element => element.value === estatus );
      dispatch(detalleSolicitud(solicitud));
      navigate(`/detalle-solicitud/${id}`);
    }
    //if(estatus === "CONDICIONADO" || estatus === "RECHAZO") {
    /*if(estatus !== null && estatus !== "") {
            dispatch(detalleSolicitud(solicitud));
            navigate(`/detalle-solicitud/${id}`);
        }*/
    /*dispatch(retomarSolicitud(solicitud));
        navigate("/solicitud");*/
  };

  const mapSolicitudToFormData = (solicitud) => {
    const rfcValue = solicitud.rfc;
    const rfcBase = rfcValue.length > 3 ? rfcValue.slice(0, -3) : rfcValue;
    const homoclave = rfcValue.length > 3 ? rfcValue.slice(-3) : "";
    const coloniaManual = String(solicitud.colonia) === "-1";
    const fechaNacimiento = solicitud.fechaNacimiento
      ? revertDate(solicitud.fechaNacimiento)
      : "";
    const seller = solicitud.seller;
    // si no existe seller mandar un error
    if (!seller) {
      dispatch(
        showAlert(MensajesAlertas.mensajeNoDuplicarSolicitud, () =>
          dispatch(hideAlert()),
        ),
      );
      return;
    }
    const tipoVivienda = solicitud.tipoVivienda;
    // si no existe tipoVivienda mandar un error
    if (!tipoVivienda) {
      dispatch(
        showAlert(MensajesAlertas.mensajeNoDuplicarSolicitud, () =>
          dispatch(hideAlert()),
        ),
      );
      return;
    }

    return {
      seller: seller,
      primerNombre: solicitud.nombre || "",
      segundoNombre: solicitud.segundoNombre || "",
      primerApellido: solicitud.apellidoPaterno || "",
      segundoApellido: solicitud.apellidoMaterno || "",
      genero: solicitud.genero || "",
      estadoCivil: solicitud.estado_civil || "",
      fechaNacimiento: fechaNacimiento,
      dependientesEconomicos: solicitud.dependientes_economicos || "",
      rfc: rfcBase,
      homoclave: homoclave,
      nivelEstudios: solicitud.nivel_de_estudios || "",
      vehiculosCuenta: solicitud.cuenta_con_vehiculo || "",
      calle: solicitud.calle || "",
      noExterior: solicitud.noExterior,
      noInterior: solicitud.noInterior,
      codigoPostal: solicitud.codigoPostal,
      vivienda: tipoVivienda,
      colonia: coloniaManual ? "" : solicitud.coloniaStr,
      existeColonia: coloniaManual,
      anadeColonia: coloniaManual ? solicitud.coloniaStr : "",
      alcaldia: solicitud.municipio,
      estado: solicitud.estado,
      aniosDomicilio: solicitud.aniosDomicilio,
      mesesDomicilio: solicitud.mesesDomicilio,
      numeroCelular: solicitud.telefonoMovil,
      confirmarCelular: solicitud.telefonoMovil,
      telefonoFijo: solicitud.telefonoFijo,
      correoElectronico: solicitud.email,
    };
  };

  const replicarSolicitud = (event, solicitud) => {
    event.stopPropagation();
    if (!dataUser?.user || !sucursalSelec?.sucursalSeleccionada) {
      return;
    }
    const dataForm = mapSolicitudToFormData(solicitud);
    const idCotizaciones = (() => {
      if (Array.isArray(solicitud.idCotizaciones)) {
        return solicitud.idCotizaciones
          .map((item) => Number(item))
          .filter((item) => Number.isFinite(item));
      }
      if (typeof solicitud.idCotizaciones === "string") {
        return solicitud.idCotizaciones
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item !== "")
          .map((item) => Number(item))
          .filter((item) => Number.isFinite(item));
      }
      if (typeof solicitud.idCotizaciones === "number") {
        return [solicitud.idCotizaciones];
      }
      return [];
    })();
    if (idCotizaciones.length === 0) {
      dispatch(
        showAlert(MensajesAlertas.mensajeNoDuplicarSolicitud, () =>
          dispatch(hideAlert()),
        ),
      );
      return;
    }
    const solicitudBase = {
      dataSolicitud: { ...solicitud, idCotizaciones: idCotizaciones },
    };
    dispatch(
      updateSaveSolicitud(
        dataForm,
        dataUser.user.correo,
        sucursalSelec,
        securityKey,
        solicitudBase,
      ),
    )
      .then((res) => {
        if (res && res.codigo === 0) {
          navigate("/solicitud");
        }
      })
      .catch(() => {});
  };

  const descripcionEstatus = (estatus, descripcionEstatus) => {
    if (estatus === null) {
      return "En proceso";
    } else if (estatus === "") {
      return descripcionEstatus;
    } else {
      return estatus;
    }
  };

  const listBody = items.map((solicitud, index) => {
    const estatusSelect = listaEstatus.find(
      (element) => element.value === solicitud.estatus,
    );
    //console.log(estatusSelec+" === "+solicitud.estatus);
    let claseEstatus = estatusSelect ? estatusSelect.clase : "caso-alterno";
    return (
      ((estatusSelec === solicitud.estatus &&
        (solicitud.estatusDescripcion === null ||
          solicitud.estatusDescripcion === "FACTURA ILEGIBLE")) ||
        (estatusSelec === "" &&
          solicitud.estatus === null &&
          solicitud.estatusDescripcion === null) ||
        estatusSelec === "Todos" ||
        (estatusSelec === "APROBADO" &&
          ((solicitud.estatus !== "RECHAZO" &&
            solicitud.estatus !== "CONDICIONADO" &&
            solicitud.estatus !== "RECHAZO" &&
            solicitud.estatus !== "CANCELADO" &&
            solicitud.estatus !== "" &&
            solicitud.estatus !== null) ||
            (solicitud.estatus === "" &&
              solicitud.estatusDescripcion !== "")))) && (
        <tr
          className={claseEstatus}
          key={index}
          onClick={() => terminarSolicitud(solicitud)}
        >
          <td>
            {`${solicitud.marcaVehiculo} ${solicitud.tipoVehiculo} ${solicitud.modelo}`}
          </td>
          <td>{`${solicitud?.nombre} ${solicitud?.segundoNombre} ${solicitud?.apellidoPaterno} ${solicitud?.apellidoMaterno}`}</td>
          <td>{solicitud.consecutivo}</td>
          <td>
            {descripcionEstatus(
              solicitud.estatus,
              solicitud.estatusDescripcion,
            )}
          </td>
          <td>{format(new Date(solicitud.fechaCreacion), "dd-MM-yyyy")}</td>
        </tr>
      )
    );
  });

  return (
    <Card className="card-tabla">
      <Card.Body>
        <Table className="table-solicitudes">
          <thead>
            <tr>
              <th></th>
              <th>Nombre</th>
              <th>Folio</th>
              <th>Estado</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>{listBody}</tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default CardTabla;
